import React from 'react';
import ReactDOM from 'react-dom/client';
import styled from "styled-components";

// Main components and hooks
import MobileDeviceIconBadge from "./MobileDeviceIconBadge";
import { useMobileStatus } from "./hooks/uiInteractions/useMobileStatus";

import ToastNotification, { toast } from '../Common/ToastNotification';
import { useWizardLauncher } from './hooks/useWizardLauncher';


const Label = styled.p`
  cursor: pointer; 
  font-size: 0.4em;
  font-weight: 500;
  margin-top:-5px;
`;

const Icon = styled.i`
  cursor: pointer;
`;

const MobileMenuIcon = ({ activeTab }) => {
  const { needsUpdate } = useMobileStatus();
  const { launchWizard, ConfirmModalComponent } = useWizardLauncher();

  const handleIconClick = (event) => {
    event.preventDefault();
    launchWizard();
  };

  if (activeTab === 'reports') {
    return null;
  }

  return (
    <>
      <a
        href="#"
        onClick={handleIconClick}
        className="mobile-icon-enabled"
        data-original-title="Mobile View"
        style={{ textDecoration: 'none', color: 'inherit', textAlign: 'center' }}
      >
        <Icon className="fa pf-mobile icon-gradient" />
        <Label>Mobile</Label>
        <MobileDeviceIconBadge isVisible={needsUpdate} />
      </a>
      {ConfirmModalComponent}
      <ToastNotification />
    </>
  );
};

MobileMenuIcon.render = function (targetElementId, props) {
  const targetElement = document.getElementById(targetElementId);

  if (targetElement) {
    let root = targetElement._reactRoot;
        if (!root) {
            root = ReactDOM.createRoot(targetElement);
            targetElement._reactRoot = root;
        }
        root.render(<MobileMenuIcon {...props} />);
  } else {
    console.error(`Mobile Icon: Target element with ID "${targetElementId}" not found.`);
  }
}

export default MobileMenuIcon;